import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UsersService } from 'app/features/user-management/services/users.service';
import { AuthorizationService } from 'core/services/auth/authorization.service';
import { ContextService } from 'core/services/context.service';
import { filter, switchMap } from 'rxjs';
import { RolesEnum } from 'shared/enums';

@Directive({
  selector: '[appUserRoles]',
})
export class UserRolesDirective implements OnInit {
  private usersService = inject(UsersService);
  private authService = inject(AuthorizationService);
  private contextService = inject(ContextService);
  @Input() public appUserRoles: RolesEnum[] = [];
  @Input() public appUserRolesSiteId: string | null = null;
  @Input() public appUserRolesAction: 'hide' | 'disable' = 'hide';

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  public ngOnInit(): void {
    this.usersService
      .getLoggedInUserWithRoles()
      .pipe(
        filter((user) => !!user),
        switchMap(() => this.contextService.siteId)
      )
      .subscribe(() => {
        this.applyRoleBasedAction();
      });
  }

  private applyRoleBasedAction(): void {
    const hasRequiredRole = this.authService.checkSiteRoles(this.appUserRoles, this.appUserRolesSiteId ?? undefined);
    this.viewContainer.clear();
    if (hasRequiredRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.appUserRolesAction === 'disable') {
      const view = this.viewContainer.createEmbeddedView(this.templateRef);
      view.rootNodes.forEach((node: HTMLElement) => {
        node.setAttribute('disabled', 'true');
      });
    }
  }
}
